
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"disabled-highlight",attrs:{"d":"M17.156 0H6.844a1.76 1.76 0 00-1.758 1.758v20.484c0 .97.788 1.758 1.758 1.758h10.312a1.76 1.76 0 001.758-1.758V1.758A1.76 1.76 0 0017.156 0zm1.055 19.078H8.25a.352.352 0 000 .703h9.96v2.461c0 .582-.472 1.055-1.054 1.055H6.844a1.056 1.056 0 01-1.055-1.055v-2.46h1.055a.352.352 0 100-.704H5.789V3.516h12.422v15.562zm0-16.265H5.789V1.758c0-.582.473-1.055 1.055-1.055h10.312c.582 0 1.055.473 1.055 1.055v1.054z","fill":"#00003C"}}),_c('path',{staticClass:"active-highlight",attrs:{"d":"M13.406 1.406H12a.352.352 0 100 .703h1.406a.352.352 0 100-.703zM12 20.484a1.056 1.056 0 000 2.11 1.056 1.056 0 000-2.11zm0 1.407a.352.352 0 110-.704.352.352 0 010 .704zM10.594 2.11a.352.352 0 100-.704.352.352 0 000 .703z","fill":"#E2E4EC"}})])
          )
        }
      }
    